







import { Vue, Component, Prop } from 'vue-property-decorator';
import TextArea from './TextArea.vue';
import marked from 'marked';

@Component({
  components: {
    TextArea
  }
})
export default class InputField extends Vue {
  @Prop(String) value!: string;
  @Prop(Boolean) editing!: boolean;
  @Prop(String) placeholder!: string;

  valueChanged(event: any) {
    this.$emit('change', event.target.value);
  }

  get renderedMarkdown() {
    return this.value
      ? marked(this.value, {
          headerIds: false
        } as any)
      : '';
  }
}
